// extracted by mini-css-extract-plugin
export default {"mainTitle":"Title_mainTitle__hv-ZC","secondaryTitle":"Title_secondaryTitle__24nOb"};